import React from 'react';
import HeaderDPC from './header/dpc-header';
import HeaderItAlert from  './header/dpc-header-italert';
import HeaderIoNonRischio from  './header/dpc-header-iononrischio';
import HeaderAttimoDecisivo from  './header/dpc-header-attimodecisivo';
import FooterDPC from './footer/dpc-footer';
import FooterDPCItAlert from './footer/dpc-footer-italert';
import FooterDPCIoNonRischio from './footer/dpc-footer-iononrischio';
import FooterDPCAttimoDecisivo from './footer/dpc-footer-attimodecisivo';
import BreadcrumbDPC from './dpc-breadcrumb';
import ShareButtonDPC from "./dpc-share-button";
import Helmet from "react-helmet";
import {buildMenu} from "../js/shared-functions";
import {getBreadcrumbItems,getBreadcrumbItemsDaElenco} from "../js/shared-functions";
import {withPrefix} from "gatsby";
import BackToTopDPC from './dpc-back-to-top';
import { useLocation } from '@reach/router';

export class DpcPageContainer extends React.Component {

    constructor(props) {
        super(props);
        if (typeof document !== `undefined`) {
            if(this.props.isInrAttimoDecisivo){
                const script = document.createElement("script");
                script.src = withPrefix('shikwasa.min.js');
                script.async = false;
                script.id = 'shikwasa.min.js'.split(".")[0] + '-js';
                document.body.appendChild(script);
            }

            ['jquery.min.js', 'popper.min.js', 'bootstrap-italia.min.js', 'tiny-slider.js', 'tiny-slider-init.js', 'main.js'].forEach(item => {
                const script = document.createElement("script");
                script.src = withPrefix(item);
                script.async = false;
                script.id = item.split(".")[0] + '-js';
                document.body.appendChild(script);
            });
            this.state = {checkCookie: !document.cookie.match(/^(.*;)?\s*cookies_consent\s*=\s*[^;]+(.*)?$/)}
        }

    }

    getDomainClass = (domain) => {
        if (this.props.isItAlert) {
            return 'is-subsite is-minsito-italert'
        }else if(this.props.isIoNonRischio){
            return 'is-subsite is-iononrischio'
        }else if(this.props.isInrAttimoDecisivo){
            return 'is-iononrischio is-attimodecisivo'
        }
         else {
            return domain ? 'is-subdomain' : 'is-mainsite'
        }

    };

    getTitle = () => {
        if (this.props.isItAlert) {
            return this.props.isHomepage ? "IT Alert" : this.props.title + " | IT Alert"
        }
        else if (this.props.isIoNonRischio) {
            return this.props.isHomepage ? "Io non rischio" : this.props.title + " | Io non rischio"
        }
        else if(this.props.isInrAttimoDecisivo){
            return this.props.isHomepage ? "L' Attimo decisivo" : this.props.title + " | L' Attimo decisivo"
        }
         else {
            return this.props.isHomepage ? "Dipartimento della Protezione Civile" : this.props.title + " | Dipartimento della Protezione Civile";
        }

    };

    getMenuFooter = (menuItems) => {
        if (this.props.isItAlert) {
            buildMenu(menuItems, this.props.lang, this.props.env, this.props.basePathNavbar, null, null)
        } else {
            return this.props.domain
                ? buildMenu(menuItems, this.props.lang, this.props.env, this.props.basePathNavbar, null, this.props.minisiti)
                : buildMenu(menuItems, this.props.lang, this.props.env, null, null, this.props.minisiti)
        }
    };

    componentWillUnmount() {
        if (typeof document !== `undefined`) {
            if(this.props.isInrAttimoDecisivo){
                const script = document.getElementById('shikwasa-js');
                script.parentNode.removeChild(script);
            }
            ['jquery-js', 'popper-js', 'bootstrap-italia-js', 'tiny-slider-js', 'tiny-slider-init-js', 'main-js'].forEach(item => {
                const script = document.getElementById(item);
                script.parentNode.removeChild(script);
            });
        }
    }

    getDomainScript = (props, window) =>{

        if(props.isIoNonRischio){
                        
            if(window.location.hostname.includes("www.iononrischio.gov")){
                return "9e93807d-be52-4fdb-8373-27f4a339a9c2";
            }else if (window.location.hostname.includes("www.iononrischio")){
                return "a0c70087-8063-442e-9ca4-d3e442482af5"
            }else if(window.location.hostname.includes("iononrischio.protezionecivile.gov")){
                return "e8e5cb4f-185a-4ce8-b3a3-a230989a893f";
            }else{
                return "b27ce7d7-ae1f-4f85-b2e7-ef3524d1ed9d";
            }
        }
        else if(props.isItAlert){
        
            if(window.location.hostname.includes(".gov")){
                return "4b50ce36-bb57-4c9e-93cb-bd8765b32c8d";
            }else{
                return "9bafcbc8-ae50-44ac-87f8-884eec60736e";
            }
        
        }else if(props.isDomande){
        
            if(window.location.hostname.includes(".gov")){
                return "6dae47d5-f231-48b2-9f5b-8534f2f2c023"
            }else{
                return "dd874027-790f-4615-9af3-ee3e48eb1e95"
            }

        }else if(props.isEmergenze){ 
    
            if(window.location.hostname.includes(".gov")){
                return "f4a75023-7845-4195-bc1f-a53b4983f98f"
            }else{
                return "6a3bdf94-74d6-415e-8e87-ee265dfdfe49"
            }
            
        } else if(props.isEventi){
        
            if(window.location.hostname.includes(".gov")){
                return "ac0b4acf-d5a7-4608-bd11-0513c373067a"
            }else{
                return "ded8358f-23d3-4644-839a-ffe5c333d6b6"
            }
           
        }else if(props.isFormazione){ 
        
            if(window.location.hostname.includes(".gov")){
                return "cc3c6260-4f61-4893-b5c0-8f4a4c4757a3"
            }else{
                return "26892384-c103-47d7-acff-bdb62de4c35d"
            }
           
        }else if(props.isGiovani){
        
            if(window.location.hostname.includes(".gov")){
                return "a560cf79-3401-4c87-94f4-58bb98234cdc"
            }else{
                return "6fb489a6-def3-4c18-9653-7bcfbb94e56d"
            }
          
        }else if(props.isMappe){  
                        
            if(window.location.hostname.includes(".gov")){
                return "be1b5661-d4e0-4991-b770-033f966e7418"
            }else{
                return "64a7d939-677c-4555-a9c4-c002e56b3814"
            }
          
        } else if(props.isNazionale){ 
        
            if(window.location.hostname.includes(".gov")){
                return "0591a391-04f2-4b21-a075-84185fd92962"
            }else{
                return "af9911c9-4653-45a7-a407-fc205047eff9"
            }
           
        } else if(props.isPnrr){ 
        
            if(window.location.hostname.includes(".gov")){
                return "2ad8ffac-6993-41db-a9fb-083adb335a8c"
            }else{
                return "40bb022a-b5c9-40c4-88f4-b4e395e5ae98"
            }
           
        }else if(props.isRelazioni){
        
            if(window.location.hostname.includes(".gov")){
                return "087099f0-7b9d-4803-a701-3315b5220523"
            }else{
                return "114c0572-89b0-44f3-b249-c90e6bd95611"
            }
           
        }else if(props.isRischi){
        
            if(window.location.hostname.includes(".gov")){
                return "255b571f-9924-4809-a015-f295e82b5fa1"
            }else{
                return "7c679cfa-2033-48e1-aecc-40ba755f5086"
            }
            
        }else if(props.isVolontariato){
        
            if(window.location.hostname.includes(".gov")){
                return "b4e7d5d1-e7fb-48bb-b7ff-3e80f9363e73"
            }else{
                return "5bda2656-dc74-4378-978f-1f321239ac33"
            }
            
        }else{                  
        
            if(window.location.hostname.includes(".gov")){
                return "bb9c183b-4e88-4ddd-b726-8573403b0955"
            }else{
                return "6be676fe-cd7f-4b39-9b35-70bf6821d346"
            }
        }
    };

    getPathLanguage = (lingua, slug) => {
        if (slug) {
            slug = slug.charAt(0) === '/' ? `${slug.slice(1)}` : slug;
            if (typeof window !== `undefined` && (window.location.pathname.split("/")[1] !== lingua)) {
                return `https://${window.location.hostname}/${lingua}/${slug}`;
            }
        } else {
            if(typeof window !== `undefined`){
                return `https://${window.location.hostname}/${lingua}/`;
            }
        }
    };


    render() {
        const { location } = this.props;
        return (
            <div>
                <Helmet
                    bodyAttributes={{
                        class: this.getDomainClass(this.props.domain)
                    }}
                    htmlAttributes={{
                        lang: typeof window !== `undefined` ? window.location.pathname.split("/")[1] : null
                    }}
                    meta={[
                        {name: "twitter:card", content: "summary_large_image"},
                        {name: "twitter:url", content: this.props.slug},
                        {
                            name: "twitter:title",
                            content: this.props.title ? this.props.title : this.props.isIoNonRischio ? 'Io non rischio' : this.props.isInrAttimoDecisivo ? "L'attimo decisivo" :this.props.isItAlert ? 'It Alert': 'Dipartimento della Protezione Civile'
                        },
                        {
                            name: "twitter:description",
                            content: this.props.abstractShare ? this.props.abstractShare.slice(0, 150) : this.props.isIoNonRischio ? 'Io non rischio - Buone pratiche di Protezione Civile' : this.props.isInrAttimoDecisivo ? "Io non rischio - L'attimo decisivo" :this.props.isItAlert ? 'It Alert - Sistema nazionale di allarme pubblico': 'Dipartimento della Protezione Civile-Presidenza del Consiglio dei Ministri'
                        },
                        {
                            name: "twitter:image",
                            content: this.props.immagineShare ? this.props.immagineShare : this.props.isIoNonRischio ? this.props.basePathNavbar + '/img/iononrischio.jpg' : this.props.basePathNavbar + '/img/dpc-logo-1200x630.jpg'
                        },
                    ]}
                >
                    <meta http-equiv="cache-control" content="no-cache"/>

                    <meta http-equiv="cache-control" content="no-store"/>

                    <meta http-equiv="cache-control" content="must-revalidate"/>

                    <meta http-equiv="expires" content="Sat, 07 Feb 2016 00:00:00 GMT"/>

                    <meta http-equiv="Pragma" content="no-cache"/>

                    <meta name="google-site-verification" content="x_P95sAOxaaBLu8XN65WkxmLjsgzDWVnUGPci-PU9EY"/>

                    <title>{this.getTitle()}</title>

                    {this.props.immagineShare ? <meta property="og:image" content={this.props.immagineShare}/> :
                        this.props.isIoNonRischio ?
                        <meta property="og:image" content={withPrefix('img/iononrischio.jpg')}/>
                        :
                        <meta property="og:image" content={withPrefix('img/dpc-logo-1200x630.jpg')}/>}

                    {this.props.abstractShare ?
                        <meta property="og:description" content={this.props.abstractShare.slice(0, 150)}/> : 
                        this.props.isInrAttimoDecisivo ?
                        <meta property="og:description"
                              content="Io non rischio - L'attimo decisivo"/>
                         :
                        this.props.isIoNonRischio ? 
                        <meta property="og:description"
                              content="Io non rischio - Buone pratiche di Protezione Civile"/>
                        :
                        this.props.isItAlert ? 
                        <meta property="og:description"
                              content="It Alert - Sistema nazionale di allarme pubblico"/>
                        :
                        <meta property="og:description"
                              content="Dipartimento della Protezione Civile-Presidenza del Consiglio dei Ministri"/>
                    }

                    {this.props.title ? <meta property="og:title" content={this.props.title}/> :
                    this.props.isInrAttimoDecisivo ?
                    <meta property="og:title" content={"Io non rischio - L'attimo decisivo"}/>
                    :
                    this.props.isIoNonRischio ?
                    <meta property="og:title" content={"Io non rischio - Buone pratiche di Protezione Civile"}/>
                    :
                    this.props.isItAlert ?
                    <meta property="og:title" content={"It Alert - Sistema nazionale di allarme pubblico"}/>
                    :
                        <meta property="og:title" content={"Dipartimento della Protezione Civile"}/>}

                    <meta property="og:type" content="article"/>

                    {this.props.slug && <meta property="og:url" content={this.props.slug}/>}

                    <link rel="stylesheet" href={withPrefix("css/print.css")} media="print"/>

                    { this.props.isInrAttimoDecisivo &&
                    <link rel="stylesheet" href={withPrefix("css/shikwasa.min.css")}/>
                    }

                    <link rel="alternate" hreflang={this.props.lang === "it" ? "en" : "it"} href={this.props.lang === "it" ? this.getPathLanguage("en",this.props.slugTraduzione): this.getPathLanguage("it",this.props.slugTraduzione)}/>

                {// SVILUPPO
                /*
                this.props.isIoNonRischio ?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" data-document-language="true" type="text/javascript" charset="UTF-8" data-domain-script="a0c70087-8063-442e-9ca4-d3e442482af5-test" ></script>
                :this.props.isItAlert?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="9bafcbc8-ae50-44ac-87f8-884eec60736e-test" ></script>
                :this.props.isDomande ?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="dd874027-790f-4615-9af3-ee3e48eb1e95-test" ></script>
                :this.props.isEmergenze ? 
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="6a3bdf94-74d6-415e-8e87-ee265dfdfe49-test" ></script>
                :this.props.isEventi ?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="ded8358f-23d3-4644-839a-ffe5c333d6b6-test" ></script>
                :this.props.isFormazione ? 
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="26892384-c103-47d7-acff-bdb62de4c35d-test" ></script>
                :this.props.isGiovani ?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="6fb489a6-def3-4c18-9653-7bcfbb94e56d-test" ></script>
                :this.props.isMappe ? 
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="64a7d939-677c-4555-a9c4-c002e56b3814-test" ></script>
                :this.props.isNazionale ? 
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="af9911c9-4653-45a7-a407-fc205047eff9-test" ></script>
                :this.props.isPnrr ? 
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="40bb022a-b5c9-40c4-88f4-b4e395e5ae98-test" ></script>
                :this.props.isRelazioni?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="114c0572-89b0-44f3-b249-c90e6bd95611-test" ></script>
                :this.props.isRischi?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="7c679cfa-2033-48e1-aecc-40ba755f5086-test" ></script>
                :this.props.isVolontariato?
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="5bda2656-dc74-4378-978f-1f321239ac33-test" ></script>
                :
                <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="6be676fe-cd7f-4b39-9b35-70bf6821d346-test" ></script>
                */}

                {  /*
                this.props.isIoNonRischio && typeof window !== `undefined` && window.location.hostname.includes("www.iononrischio") && !window.location.hostname.includes(".gov")?
                    <script type="text/javascript" src="https://cdn.cookielaw.org/consent/a0c70087-8063-442e-9ca4-d3e442482af5/OtAutoBlock.js" ></script>
                :null
            */}

                {// PROD
                /*
                typeof window !== `undefined` ?  
                    <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script={this.getDomainScript(this.props, window)} ></script>                  
                :null    
                */}

                <script type="text/javascript">
               {/*`function OptanonWrapper() { }`*/}
                </script>
                

                </Helmet>

                {this.props.isItAlert
                    ? <HeaderItAlert
                    slugTraduzione={this.props.slugTraduzione}
                    menuItems={this.props.menuItems}
                    env={this.props.env}
                    lang={this.props.lang}
                    basePathNavbar={this.props.basePathNavbar}
                    contenutoId={this.props.pageId}
                    minisiti={this.props.minisiti}
                    strillo={this.props.strillo}
                />
                    : this.props.isIoNonRischio ?
                    <HeaderIoNonRischio
                    slugTraduzione={this.props.slugTraduzione}
                    menuItems={this.props.menuItems}
                    env={this.props.env}
                    lang={this.props.lang}
                    basePathNavbar={this.props.basePathNavbar}
                    contenutoId={this.props.pageId}
                    minisiti={this.props.minisiti}
                    strillo={this.props.strillo}
                />
                    : this.props.isInrAttimoDecisivo ? 
                    <HeaderAttimoDecisivo
                        slugTraduzione={this.props.slugTraduzione}
                        menuItems={this.props.menuItems}
                        subdomain={this.props.domain}
                        subdomainMenuItems={this.props.subdomainMenuItems}
                        classeAggiuntivaSubnavbar={this.props.classeAggiuntivaSubnavbar}
                        env={this.props.env}
                        lang={this.props.lang}
                        basePathNavbar={this.props.basePathNavbar}
                        isHomepage={this.props.isHomepage}
                        contenutoId={this.props.pageId}
                        minisiti={this.props.minisiti}
                        isLanding={this.props.isLanding}
                    />
                    
                    :<HeaderDPC
                        slugTraduzione={this.props.slugTraduzione}
                        menuItems={this.props.menuItems}
                        subdomain={this.props.domain}
                        subdomainMenuItems={this.props.subdomainMenuItems}
                        classeAggiuntivaSubnavbar={this.props.classeAggiuntivaSubnavbar}
                        env={this.props.env}
                        lang={this.props.lang}
                        basePathNavbar={this.props.basePathNavbar}
                        isHomepagePortale={this.props.isHomepagePortale}
                        contenutoId={this.props.pageId}
                        minisiti={this.props.minisiti}
                    />}

                <main role='main' id='main'>
                    {this.props.isItAlert && !this.props.isHomepage &&
                        <div className="hero">
                            <div className="container">
                                <div className="px-custom">
                                    <div className="hero-wrapper">
                                        <h1>{this.props.title}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {!this.props.isHomepage &&
                        <div className={"container"}>
                            <div className="px-custom">
                                <div className="row">
                                    {this.props.daElenco?
                                    <BreadcrumbDPC
                                    items={getBreadcrumbItemsDaElenco(this.props.menuItems , this.props.pageId, this.props.lang, this.props.env, this.props.elencoId, this.props.breadcrumbItem, this.props.basePathNavbar)}
                                    checkTorna={this.props.checkTorna}
                                    linkTorna={this.props.linkTorna}
                                    textTorna={this.props.textTorna}
                                    lang={this.props.lang}
                                    />
                                    :
                                    <BreadcrumbDPC
                                        items={getBreadcrumbItems(!this.props.domain ? this.props.menuItems : this.props.subdomainMenuItems, this.props.pageId, this.props.lang, this.props.env, this.props.elencoId, this.props.breadcrumbItem)}
                                        checkTorna={this.props.checkTorna}
                                        linkTorna={this.props.linkTorna}
                                        textTorna={this.props.textTorna}
                                        lang={this.props.lang}
                                    />
                                    }

                                    {(!this.props.isHomepage || this.props.showCondividi) &&
                                        <ShareButtonDPC slug={this.props.slug}/>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    {this.props.children}
                </main>

                {
                    this.props.isItAlert
                        ? <FooterDPCItAlert
                            isHomepagePortale={this.props.isHomepagePortale}
                            lang={this.props.lang} portaleUrl={this.props.basePathNavbar}
                            menuFooterItems={this.props.menuFooterItems} />
                        : this.props.isInrAttimoDecisivo
                            ? <FooterDPCAttimoDecisivo
                                menuItems={this.getMenuFooter(this.props.menuItems)}
                                isHomepagePortale={this.props.isHomepagePortale}
                                lang={this.props.lang}
                                portaleUrl={this.props.basePathNavbar}
                                currentPathname={location.pathname}
                                menuFooterItems={this.props.menuFooterItems}
                                isInrAttimoDecisivo={this.props.isInrAttimoDecisivo} />
                            : this.props.isIoNonRischio
                                ? <FooterDPCIoNonRischio menuItems={this.getMenuFooter(this.props.menuItems)}
                                    isHomepagePortale={this.props.isHomepagePortale}
                                    lang={this.props.lang} portaleUrl={this.props.basePathNavbar}
                                    menuFooterItems={this.props.menuFooterItems}
                                    isInrAttimoDecisivo={this.props.isInrAttimoDecisivo} />
                                : <FooterDPC menuItems={this.getMenuFooter(this.props.menuItems)}
                                    isHomepagePortale={this.props.isHomepagePortale}
                                    lang={this.props.lang} portaleUrl={this.props.basePathNavbar}
                                    menuFooterItems={this.props.menuFooterItems}
                                    isPnrr={this.props.isPnrr} isGiovani={this.props.isGiovani} />
                }

                <BackToTopDPC/>
            </div>
        );
    }

}

export default function DpcPageContainerFunction(props) {
    const location = useLocation();
    console.log('location prefooter:', location);
    
    return <DpcPageContainer {...props} location={location} />;
}
